<template>
    <div>
        <my-search @search="searchHandler" v-model="pgData" title-placeholder="标段名称/标段编号">
            <el-form-item slot="time"></el-form-item>
            <template slot="btn">
                <el-button type="success" icon="el-icon-plus" @click="addHandler">添加中标候选人</el-button>
            </template>
        </my-search>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="标段名称" prop="bdname" min-width="220" fixed="left"></el-table-column>
            <el-table-column label="编码" prop="zhhxrcode" min-width="160"></el-table-column>
            <el-table-column label="单位名称" prop="hxrdwname" sortable min-width="150"></el-table-column>
            <el-table-column label="投标价格(元)" sortable width="130">
                <template slot-scope="scope">
                    <span v-if="scope.row.bjlx==='1'||scope.row.bjlx===null||scope.row.bjlx===''||scope.row.bjlx===undefined">
                        {{scope.row.tbjg}}
                    </span>
                    <span v-else>
                        {{scope.row.tbbj}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="评标价格(元)" sortable width="130">
                <template slot-scope="scope">
                    <span v-if="scope.row.bjlx==='1'||scope.row.bjlx===null||scope.row.bjlx===''||scope.row.bjlx===undefined">
                        {{scope.row.pbjg}}
                    </span>
                    <span v-else>
                        {{scope.row.pbbj}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="中标价格(元)" sortable width="130">
                <template slot-scope="scope">
                    <span v-if="scope.row.bjlx==='1'||scope.row.bjlx===null||scope.row.bjlx===''||scope.row.bjlx===undefined">
                        {{scope.row.zbjg}}{{scope.row.jgdwname}}{{scope.row.bzname}}
                    </span>
                    <span v-else>
                        {{scope.row.zbbj}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="状态" width="110">
                <template slot-scope="scope">
                    <state-list :row="scope.row" :config="STATE_CONF"></state-list>
                </template>
            </el-table-column>
            <el-table-column label="操作" min-width="110" fixed="right">
                <template slot-scope="scope">
                    <btn-list 
                        :row="scope.row"
                        @reload="reloadHandler"
                        :config="BTN_CONF">
                    </btn-list>
                </template>
                
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('mngUrl')}/DingBiao/ZbHxr/hxrlist.json`">
        </my-pagination>

    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'

import STATE_CONF from './config/state'
import BTN_CONF from './config/btn-list'
export default {
    mixins: [LIST_PAGE_MIXIN],
    data() {
        return{
            pgData:{
                zbprocode:this.getQuery('procode'),
                sortname:'zhhxrcode'
            },

            STATE_CONF,
            BTN_CONF
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        
    },
    created() {
       
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">

</style>
